import React from "react";
import { Button } from "reactstrap";

const Article = (props) => {
    return (
        <div class="article-container">
            <img src={props.pictureURL} alt="Article" />
            <div class="txt-container">
                <div class="txt">{props.title}</div>
                <div class="btn-container">
                    <div class="btn" onClick={() => window.open(props.article_link, "_blank")}> lire la suite </div>
                </div>
            </div>
        </div>)
}

export default Article;